import { setRequestStatus } from 'data-layer-cr/dist/network';
import { NetworkResponse } from 'data-layer-cr/dist/network/NetworkTypes';
import { AnyAction } from 'redux';

import PersonValidationResponse from 'src/models/responseTypes/PersonValidationResponse';
import processRequest from 'src/services/processRequest';
import { AsyncAppThunk, AsyncDispatch } from '../../ThunkTypes';

import {
  REQUEST_SEARCH_PERSON,
  REQUEST_SEARCH_VALIDATE_BENEFICIARY_PERSON,
  REQUEST_SEARCH_VALIDATE_PERSON,
  REQUEST_SEARCH_VALIDATE_SHAREHOLDER,
} from '../requestIdentifiers';
import { updateSearchPerson } from '../slice/personSlice';
import {
  updateSearchValidateBeneficiaryPerson,
  updateSearchValidatePerson,
} from '../slice/personValidateSlice';
import { updateSearchValidateShareholder } from '../slice/shareholderValidateSlice';

// eslint-disable-next-line import/prefer-default-export
export const requestSearchPerson =
  (idNumber: string, idType: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(REQUEST_SEARCH_PERSON, 'requesting'));
    try {
      const response = await processRequest<
        NetworkResponse<PersonValidationResponse>
      >({
        method: 'GET',
        url: `person/validate?ruc=${idNumber}&idType=${idType}`,
      });
      dispatch(updateSearchPerson(response.data));

      return dispatch(setRequestStatus(REQUEST_SEARCH_PERSON, 'success'));
    } catch (e) {
      dispatch(
        updateSearchPerson({
          isValidPerson: false,
          personExist: false,
          possibleIssue: 'Connection Error',
        }),
      );
      return dispatch(setRequestStatus(REQUEST_SEARCH_PERSON, 'failure'));
    }
  };

export const requestSearchValidatePerson =
  (idNumber: string, idType: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(REQUEST_SEARCH_VALIDATE_PERSON, 'requesting'));
    try {
      const response = await processRequest<
        NetworkResponse<PersonValidationResponse>
      >({
        method: 'GET',
        url: `person/validate?ruc=${idNumber}&idType=${idType}`,
      });
      dispatch(updateSearchValidatePerson(response.data));

      return dispatch(
        setRequestStatus(REQUEST_SEARCH_VALIDATE_PERSON, 'success'),
      );
    } catch (e) {
      dispatch(
        updateSearchValidatePerson({
          isValidPerson: false,
          personExist: false,
          possibleIssue: 'Connection Error',
        }),
      );
      return dispatch(
        setRequestStatus(REQUEST_SEARCH_VALIDATE_PERSON, 'failure'),
      );
    }
  };

export const requestSearchValidateBeneficiaryPerson =
  (idNumber: string, idType: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(
      setRequestStatus(
        REQUEST_SEARCH_VALIDATE_BENEFICIARY_PERSON,
        'requesting',
      ),
    );
    try {
      const response = await processRequest<
        NetworkResponse<PersonValidationResponse>
      >({
        method: 'GET',
        url: `person/validate?ruc=${idNumber}&idType=${idType}`,
      });
      dispatch(updateSearchValidateBeneficiaryPerson(response.data));

      return dispatch(
        setRequestStatus(REQUEST_SEARCH_VALIDATE_BENEFICIARY_PERSON, 'success'),
      );
    } catch {
      dispatch(
        updateSearchValidateBeneficiaryPerson({
          isValidPerson: false,
          personExist: false,
          possibleIssue: 'Connection Error',
        }),
      );
      return dispatch(
        setRequestStatus(REQUEST_SEARCH_VALIDATE_BENEFICIARY_PERSON, 'failure'),
      );
    }
  };

export const requestSearchValidateShareholder =
  (idNumber: string, idType: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(
      setRequestStatus(REQUEST_SEARCH_VALIDATE_SHAREHOLDER, 'requesting'),
    );
    try {
      const response = await processRequest<
        NetworkResponse<PersonValidationResponse>
      >({
        method: 'GET',
        url: `person/validate?ruc=${idNumber}&idType=${idType}`,
      });
      dispatch(updateSearchValidateShareholder(response.data));

      return dispatch(
        setRequestStatus(REQUEST_SEARCH_VALIDATE_SHAREHOLDER, 'success'),
      );
    } catch (e) {
      dispatch(
        updateSearchValidateShareholder({
          isValidPerson: false,
          personExist: false,
          possibleIssue: 'Connection Error',
        }),
      );
      return dispatch(
        setRequestStatus(REQUEST_SEARCH_VALIDATE_SHAREHOLDER, 'failure'),
      );
    }
  };
